/**
 * Resolve membership flags for a provider id against My Vendors API id sets.
 */
export function getMyVendorMembershipState(providerId, sets = {}) {
  const id = String(providerId || "");
  const {
    providerIds = new Set(),
    manualProviderIds = new Set(),
    engagedProviderIds = new Set(),
    hiddenProviderIds = new Set(),
  } = sets;

  const isInMyVendors = providerIds.has(id);
  const isManual = manualProviderIds.has(id);
  const isHidden = hiddenProviderIds.has(id);
  const isEngaged = engagedProviderIds.has(id) || (isInMyVendors && !isManual);

  return { isInMyVendors, isManual, isEngaged, isHidden };
}

export function buildMyVendorMembershipSets({
  providerIds = [],
  manualProviderIds = [],
  engagedProviderIds = [],
  hiddenProviderIds = [],
} = {}) {
  return {
    providerIds: new Set(providerIds.map(String)),
    manualProviderIds: new Set(manualProviderIds.map(String)),
    engagedProviderIds: new Set(engagedProviderIds.map(String)),
    hiddenProviderIds: new Set(hiddenProviderIds.map(String)),
  };
}
